<template>
  <!-- <div class="menu" style="width: 64px"> -->
  <div class="menu" :style="{ width: menuWidth }">
    <el-scrollbar style="height: 100%">
      <div class="logobox">
        <div class="logoborder">
          <img class="logoimg" src="@/assets/imgs/logos.png" alt="" />
        </div>
      </div>

      <el-menu
        :default-active="activePath"
        class="el-menu-vertical-demo my-el-menu"
        @open="handleOpen"
        @close="handleClose"
        :collapse="isHideMenu"
        :collapse-transition="false"
        :unique-opened="true"
        text-color="#e9ebf0"
        background-color="#0875b0"
        :router="true"
      >
        <!-- 菜单 -->
        <el-submenu
          v-for="(item, index) in menus"
          :index="item.link"
          :key="index"
        >
          <template slot="title">
            <i class="iconfont" :class="item.icon"></i>
            <span
              slot="title"
              v-show="menuWidth == '200px'"
              v-text="item.title"
            ></span>
          </template>
          <el-menu-item
            v-for="mitem in item.subMenus"
            :index="mitem.link"
            :key="mitem.id"
          >
            <i
              class="iconfont"
              :class="mitem.icon"
              style="color: #e9ebf0; margin-right: 10px"
            ></i
            >{{ mitem.title }}
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { brequest } from '@/utils/brequest'
export default {
  inject: ['reload'],
  props: {
    menuWidth: {
      type: String,
      default: '200px'
    }
  },
  data() {
    return {
      menus: [
        {
          id: 26,
          title: '系统管理',
          icon: 'icon-dashboard24',
          link: '26',
          order: 99999,
          parentId: 0,
          subMenus: [
            {
              id: 27,
              icon: 'icon-caozuoyibiaopan-278',
              link: '/dictionary',
              order: 100002,
              parentId: 26,
              title: '字典管理'
            }
          ]
        },
        {
          id: 27,
          title: '基础维护',
          icon: 'icon-gongzuotongji',
          link: '27',
          order: 99999,
          parentId: 0,
          subMenus: [
            {
              id: 28,
              icon: 'icon-dianjianguanli',
              link: '/apparatus',
              order: 100003,
              parentId: 26,
              title: '仪器管理'
            },
            {
              id: 29,
              icon: 'icon-xiangmu',
              link: '/dynamic',
              order: 100004,
              parentId: 27,
              title: '设备动态属性'
            },
            {
              id: 30,
              icon: 'icon-xiangmu1',
              link: '/document',
              order: 100005,
              parentId: 27,
              title: '文档管理'
            },
            {
              id: 31,
              icon: 'icon-liebiao',
              link: '/script',
              order: 100006,
              parentId: 27,
              title: '检测项判定脚本'
            }
          ]
        },
        {
          id: 28,
          title: '业务管理',
          icon: 'icon-shebeiOEE',
          link: '28',
          order: 99998,
          parentId: 0,
          subMenus: [
            {
              id: 28,
              icon: 'icon-jiaoseguanli1',
              link: '/checkreport',
              order: 100004,
              parentId: 29,
              title: '检测模板管理'
            },
            {
              id: 29,
              icon: 'icon-shuipingjunfen\n',
              link: '/checkinfo',
              order: 100004,
              parentId: 30,
              title: '检测模板详情管理'
            },
            {
              id: 30,
              icon: 'icon-yidongyunkongzhitaiicon45',
              link: '/training',
              order: 100008,
              parentId: 31,
              title: '培训附件管理'
            }
          ]
        },
        {
          id: 2,
          icon: 'icon-yonghu',
          link: '2',
          order: 200000,
          title: '用户',
          parentId: 0,
          subMenus: [
            {
              icon: 'icon-jiaoseguanli2',
              id: 15,
              link: '/users',
              order: 200010,
              parentId: 2,
              title: '用户管理'
            },
            {
              icon: 'icon-ico-',
              id: 16,
              link: '/datarights',
              order: 200020,
              parentId: 2,
              title: '数据权限'
            }
          ]
        },
        {
          icon: 'icon-yonghu1',
          id: 3,
          title: '角色',
          link: '3',
          order: 300000,
          parentId: 0,
          subMenus: [
            {
              icon: 'icon-yonghuliebiao',
              id: 17,
              link: '/rolerights',
              order: 300010,
              parentId: 3,
              title: '角色权限'
            }
          ]
        }
      ],
      // 是否隐藏菜单
      isHideMenu: false,
      activePath: ''
    }
  },
  methods: {
    async queryUserMenus() {
      let ret = await brequest({
        url: '/back/user/queryUserMenus',
        method: 'post'
      })
      //权限id判断是否展示子菜单
      this.menus = ret
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    }
  },
  watch: {
    menuWidth(newData) {
      this.isHideMenu = newData == '200px' ? false : true
    }
  },
  mounted() {
    this.queryUserMenus()
    this.activePath = this.$route.path
  }
}
</script>

<style lang="scss" scoped>
// menu
.menu {
  width: 200px;
  height: 100%;
  // background-color: #263445;
  background-color: #0875b0;
  // background-image: linear-gradient(45deg, #16ceb9, #6648ff);
  transition: all 0.3s;
  .logobox {
    height: 50px;
    line-height: 50px;
    // color: #9d9d9d;
    color: #e9ebf0;
    font-size: 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0px;
    .logoborder {
      border-radius: 50%;
      width: 50px;
      height: 50px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      .logoimg {
        height: 36px;
      }
    }
  }

  .el-menu {
    border: none;

    .iconfont {
      // color: #c3c8d3;
      color: #e9ebf0;
      font-size: 18px;
      font-weight: bold;
      margin-right: 5px;
    }
    .el-menu-item .iconfont {
      font-size: 16px !important;
    }
    .el-menu-item i {
      color: #e9ebf0 !important;
    }
    .el-menu-item.is-active {
      color: #fff !important;
      font-weight: 900;
    }
    .el-menu-item.is-active i {
      color: #fff !important;
      font-weight: 900;
    }
  }
}
</style>
